import { createSlice } from "@reduxjs/toolkit";
import { AUTHENTICATION } from "../../constants";

const initialState: any = {
    headerBreadcam: sessionStorage.getItem(AUTHENTICATION.SHARED.PROFILE_HEADER) ?? '',
    loader: false,
    setS3DataKey: {},
    setLanguage: 'English'
};

const userSlice = createSlice({
    name: "statics",
    initialState,
    reducers: {
        headerBreadcam: (state, action) => {
            state.headerBreadcam = action.payload;
        },
        loader: (state, action) => {
            state.loader = action.payload;
        },
        setS3DataKey: (state, action) => {
            state.setS3DataKey = action.payload;
        },
        setLanguage: (state, action) => {
            state.setLanguage = action.payload;
        },
    },
});
export const { headerBreadcam, loader, setS3DataKey } = userSlice.actions;
export default userSlice.reducer;